import client from "../../../api/client";

export default async function getCompleteUserProfile() {
  const response = await client.get("/user/complete-user-profile");
  return response.data;
}